import { z } from 'zod';

// Guard the complete display source, not only the highest-priority field.
// A worker can rewrite HTML while detailed notes still take precedence.
export const pulseContentSnapshotSchema = z.object({
  htmlContent: z.string().nullable(),
  detailedNotes: z.string().nullable(),
  referenceTextSection: z.string().nullable(),
}).strict();

export type PulseContentSnapshot = z.infer<typeof pulseContentSnapshotSchema>;

export function pulseContentSnapshot(content: Partial<PulseContentSnapshot>): PulseContentSnapshot {
  return {
    htmlContent: content.htmlContent ?? null,
    detailedNotes: content.detailedNotes ?? null,
    referenceTextSection: content.referenceTextSection ?? null,
  };
}

export function displayedPulseContent(content: PulseContentSnapshot): string {
  return content.detailedNotes || content.htmlContent || content.referenceTextSection || '';
}